import {ReactElement, useEffect, useState} from 'react';
import {useMutation, useQueryClient} from 'react-query';
import {useDispatch, useSelector} from 'react-redux';
import {useAuth} from '../../../../config/AuthProvider/authProvider';
import {DOCUMENT_TYPES, LOAN_CARD_INFO} from '../../../../config/cacheKey';
import LayoutWithoutDrawer from '../../../../layouts/LayoutWithoutDrawer';
import {IDocumentTypeHints} from '../../../../models/basicInformation.model';
import {IGetLoansInfoResponse} from '../../../../models/registration.model';
import {changeRouteType} from '../../../../redux/handleBackBtn/handleBackBtnSlice';
import {setHeaderTitle} from '../../../../redux/headerTitle/headerTitleSlice';
import {RootState} from '../../../../redux/store';
import {GetDocumentTypes} from '../../../../services/basicInformation.service';
import {GetLoanInfo} from '../../../../services/loan.service';
import BasicInforContainer from '../../../basicInformation/basicInfoContainer';
import Accept from '../../../loanResult/accept';
import Reject from '../../../loanResult/reject';
import WaitForBank from '../../../loanResult/waitForBank';
import AdditionalStep from '../../../requestSteps/additionInfo/additionalStep';
import CheckDocument from '../../../requestSteps/cheques/checkDocument/checkDocument';
import DrawerBody from '../../../requestSteps/drawerBody/drawerBody';
import WaitCustomersDocument from '../../../requestSteps/form/waitCustomersDocument';
import OnlinePrePayment from '../../../requestSteps/inquiryFee/resultPayment/onlinePrePayment';
import WaitForInquiry from '../../../requestSteps/inquiryFee/waitForInquiry';
import WaitSign from '../../../signContract/waitSign';
import LoanTemplateContainer from '../Loans/loanTemplate/LoanTemplateContainer';
import PrePayment from '../Loans/PrePayment';
import {setLoanCalculationResult} from '../../../../redux/loanCalculationResult/loanCalculationResultSlice';

export default function ContainerRegisterLoan({
    setTabChild,
    refKey,
}: {
    setTabChild: (id: number) => void;
    refKey: string;
}) {
    const {referenceKey, setRefKey} = useAuth();
    const [stepMain, setStepMain] = useState<string>('');
    const [step, setStep] = useState<string>('');
    const queryClient = useQueryClient();
    const [content, setContent] = useState<ReactElement>();

    const {mutateAsync: getLoanInfoMutation} = useMutation(GetLoanInfo, {
        onSuccess: (data: IGetLoansInfoResponse) => {
            if (data != null) {
                setStepMain(data.loanRequestStatusId);
                setRefKey(data.referenceKey);
            } else {
                setStepMain('calculator');
            }
            // queryClient.setQueryData(LOAN_CARD_INFO, data);
            dispatch(setLoanCalculationResult(data));
        },
    });
    const {mutateAsync: documentTypeMutation} = useMutation(GetDocumentTypes, {
        onSuccess: (data: IDocumentTypeHints[]) => {
            localStorage.setItem(DOCUMENT_TYPES, JSON.stringify(data));
        },
    });
    const dispatch = useDispatch();
    const back = useSelector(
        (state: RootState) => state.prevAndNextState.nextState
    );
    useEffect(() => {
        dispatch(changeRouteType({routeType: 'loans'}));
        dispatch(
            setHeaderTitle({
                header: ' ثبت درخواست جدید',
                parentRoute: null,
                color: 'var(--header-color)',
            })
        );
        documentTypeMutation();
        return () => {
            sessionStorage.setItem(
                'HAS_INPROGRESS',
                JSON.stringify({inProgress: false})
            );
        };
    }, []);
    //for type parent
    useEffect(() => {
        if (back === 'confirmLoanTemplate') {
            setStepMain('calculator');
        }
    }, [back]);
    useEffect(() => {
        // if (stepMain !== 'calculator')

        if (
            queryClient.getQueryData('ONLINE_PREPAYMENT') === 'onlinePrepayment'
        ) {
            setStepMain('onlinePryPaymentReceipt');
        } else if (referenceKey == null && !refKey) {
            setStepMain('calculator');
            queryClient.setQueryData('ONLINE_PREPAYMENT', '');
        } else {
            getLoanInfoMutation({referenceKey: refKey || referenceKey!});
        }
    }, [step]);
    useEffect(() => {
        switch (stepMain) {
            case 'calculator':
                return setContent(
                    <LayoutWithoutDrawer>
                        <LoanTemplateContainer
                            setStep={setStep}
                            setTabChild={setTabChild}
                        />
                    </LayoutWithoutDrawer>
                );
            case 'onlinePryPaymentReceipt':
                return setContent(
                    <LayoutWithoutDrawer>
                        <OnlinePrePayment
                            referenceKey={referenceKey!}
                            setStep={setStep}
                        />
                    </LayoutWithoutDrawer>
                );
            case 'TemporaryRegistered':
                return setContent(
                    <LayoutWithoutDrawer>
                        <BasicInforContainer
                            referenceKey={referenceKey!}
                            setStep={setStep}
                            back="calculator"
                        />
                    </LayoutWithoutDrawer>
                );
            case 'WaitForInquiryPayment':
            case 'WaitForInquiry':
            case 'WaitForInquiry':
            case 'InquiryRejected':
                return setContent(
                    <DrawerBody>
                        <WaitForInquiry
                            referenceKey={referenceKey!}
                            setStep={setStep}
                            stepMain={stepMain}
                        />
                    </DrawerBody>
                );

            case 'WaitForCustomerDocument':
                return setContent(
                    <WaitCustomersDocument
                        referenceKey={referenceKey!}
                        setStep={setStep}
                    />
                );
            case 'WaitForRequestApprove':
                return setContent(
                    <DrawerBody>
                        <CheckDocument
                            referenceKey={referenceKey!}
                            setStep={setStep}
                        />
                    </DrawerBody>
                );
            case 'WaitForSalaryDeduction':
                return setContent(
                    <DrawerBody>
                        <AdditionalStep
                            referenceKey={referenceKey!}
                            setStep={setStep}
                        />
                    </DrawerBody>
                );
            case 'WaitForDocumentReceiveApprove':
                return setContent(
                    <DrawerBody>
                        <CheckDocument
                            referenceKey={referenceKey!}
                            setStep={setStep}
                            stepMain={stepMain}
                        />
                    </DrawerBody>
                );
            case 'WaitForPrepayment':
                return setContent(
                    <DrawerBody>
                        <PrePayment
                            referenceKey={referenceKey!}
                            setStep={setStep}
                            stepMain={stepMain}
                        />
                    </DrawerBody>
                );
            case 'WaitForCustomerContractSign':
                return setContent(
                    <DrawerBody>
                        <WaitSign
                            referenceKey={referenceKey!}
                            setStep={setStep}
                            stepMain={stepMain}
                        />
                    </DrawerBody>
                );
            case 'WaitForSendToBank':
                return setContent(
                    <DrawerBody>
                        <WaitForBank />
                    </DrawerBody>
                );
            case 'WaitForBankApprove':
            case 'Assigned':
                return setContent(
                    <DrawerBody>
                        <Accept
                            setTabChild={setTabChild}
                            referenceKey={referenceKey!}
                            setStep={setStep}
                            stepMain={stepMain}
                        />
                    </DrawerBody>
                );
            case 'CanceledByCustomer': //todo add status
            case 'CanceledBySetad':
                return setContent(
                    <DrawerBody>
                        <Reject setStep={setStep} />
                    </DrawerBody>
                );

            default:
                break;
        }
    }, [stepMain]);
    return <div>{content}</div>;
}
